import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { permissionsQuerySchema } from './permissions-query-schema';
import { userRoleQueryLinkerSchema } from './user-role-query-linker-schema';

export const userRoleQuerySchema = z.object({
  ...userRoleQueryLinkerSchema.shape,
  permissions: z.array(permissionsQuerySchema),
});

export type UserRoleQuerySchema = z.infer<typeof userRoleQuerySchema>;

export const userRoleQueryAllSchema = paginatedResponseSchema(userRoleQuerySchema);

export type UserRoleQueryAllSchema = z.infer<typeof userRoleQueryAllSchema>;
